(() => {
  const init = () => {
    const builder = document.getElementById('detergent-builder');
    const isHome = window.location.pathname === (window.Shopify?.routes?.root || '/');
    const previewId = window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null;
    const sameStore = url => url.origin === location.origin || ['firsteditionsco.com','www.firsteditionsco.com','dfc7e7.myshopify.com'].includes(url.hostname);
    document.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (!raw || /^(mailto:|tel:|javascript:)/i.test(raw)) return;
      let url; try { url = new URL(raw,location.href); } catch (_) { return; }
      if (!sameStore(url)) return;
      const isShopping = url.pathname === '/pages/shop' || (url.hash === '#detergent-builder' && ['/',location.pathname].includes(url.pathname)) || link.hasAttribute('data-fec-home-builder');
      if (!isShopping) return;
      const scent = url.searchParams.get('plan_scent') || (location.pathname === '/pages/shop' ? new URLSearchParams(location.search).get('plan_scent') : null);
      if (['high-lady','shadow-daddy'].includes(scent)) link.dataset.fecScentIntent = scent;
      if (isHome && builder) {
        link.setAttribute('href','#detergent-builder');
        link.dataset.fecBuilderLink = 'true';
      } else {
        const home = new URL(window.Shopify?.routes?.root || '/',location.origin);
        if (previewId) home.searchParams.set('preview_theme_id',previewId);
        if (link.dataset.fecScentIntent) home.searchParams.set('plan_scent',link.dataset.fecScentIntent);
        home.hash='detergent-builder'; link.href=home.href;
      }
    });
    document.querySelectorAll('a[href]').forEach(link=>{
      let url;try{url=new URL(link.getAttribute('href'),location.href)}catch{return}
      if(!sameStore(url) || !(url.pathname==='/pages/reviews' || url.hash==='#customer-reviews')) return;
      if(isHome && document.getElementById('customer-reviews')) {link.setAttribute('href','#customer-reviews');link.dataset.fecReviewLink='true';}
      else {const home=new URL('/',location.origin);if(previewId)home.searchParams.set('preview_theme_id',previewId);home.hash='customer-reviews';link.href=home.href;}
    });
    if (!isHome || !builder) return;
    const header = document.querySelector('.fec-site-chrome');
    const sizeHeader = () => builder.style.setProperty('--fec-compact-header',`${Math.ceil(header?.getBoundingClientRect().height || 100)}px`);
    sizeHeader(); if (header && window.ResizeObserver) new ResizeObserver(sizeHeader).observe(header);
    document.addEventListener('click',event => {
      const link = event.target.closest('a[data-fec-builder-link],a[data-fec-review-link],a[data-fec-edition-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.dataset.fecScentIntent) document.dispatchEvent(new CustomEvent('fec:select-scent',{detail:{scent:link.dataset.fecScentIntent}}));
      const menu = link.closest('details'); if (menu) menu.open = false;
      const destination=link.hasAttribute('data-fec-edition-link')?document.getElementById('inside-every-edition'):link.dataset.fecReviewLink?document.getElementById('customer-reviews'):builder;
      if (!destination) return;
      sizeHeader(); destination.focus({preventScroll:true});
      window.scrollTo({top:Math.max(0,destination.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 100) - 16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      const url = new URL(location.href); if(previewId)url.searchParams.set('preview_theme_id',previewId); url.hash=destination.id; history.replaceState(history.state,'',url);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

(() => {
  const init=()=>{
    const bar=document.querySelector('[data-fec-announcement]');if(!bar)return;
    const track=bar.querySelector('[data-fec-marquee-track]'),group=bar.querySelector('[data-fec-marquee-group]');
    const size=()=>{
      track.querySelectorAll('[data-fec-marquee-clone]').forEach(el=>el.remove());
      const distance=group.getBoundingClientRect().width;if(!distance)return;
      track.style.setProperty('--fec-marquee-distance',`${distance}px`);
      track.style.setProperty('--fec-marquee-duration',`${distance/46}s`);
      // Enough identical, inert text groups to cover the widest viewport throughout the loop.
      for(let n=0;n<Math.ceil(bar.clientWidth/distance)+1;n++){
        const clone=group.cloneNode(true);clone.removeAttribute('data-fec-marquee-group');
        clone.dataset.fecMarqueeClone='';clone.setAttribute('aria-hidden','true');clone.inert=true;track.append(clone);
      }
      bar.dataset.marqueeReady='true';
    };
    size();document.fonts?.ready.then(size);if(window.ResizeObserver)new ResizeObserver(size).observe(bar);
  };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
